import unorm from 'unorm';

const normalize = (value: string) => {
  return value
    ? unorm
        .nfd(value)
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/(\s|\/|\||\\|\*|\<|\>|\&|\?|\+|\=)/g, '_')
        .replace(/(\(|\))/g, '')
        .toLowerCase()
    : '';
};

export default normalize;
